import APIClient from '@/shared/http/clients/api'
import APIClientUpload from '../../clients/apiupload'

const resourceName = 'gedarquivo'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAllPaging = (gedFolderID, limit, index, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/pasta/${gedFolderID}?limit=${limit}&index=${index}`, data, config)
const GetAllByFolder = (gedFolderID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/pasta/${gedFolderID}`, data, config)
const GetSearchPaging = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/search?limit=${limit}&index=${index}`, data, config)
const Get = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/${id}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)
const UpdateStatus = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/status`, data, config)
const Delete = (id, data = {}, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${id}`, data, config)
const Upload = (companyID, gedFileID, data = {}, config = {}) => APIClientUpload.post(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}/upload/${gedFileID}`, data, config)
const Download = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/download`, data, config)
const DownloadById = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/download/${id}`, data, config)

const GedFileRepository = {
  GetAllPaging,
  GetAllByFolder,
  GetSearchPaging,
  Get,
  Create,
  Update,
  UpdateStatus,
  Delete,
  Upload,
  Download,
  DownloadById
}

export default GedFileRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/gedfile.js